import { render, staticRenderFns } from "./glossary.vue?vue&type=template&id=3670c9da"
import script from "./glossary.vue?vue&type=script&lang=js"
export * from "./glossary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotInternal: require('/home/runner/_work/app-hotmart-legal/app-hotmart-legal/components/Templates/Internal/Internal.vue').default})
